// Site content for Angelo Quitugua — The Nightlife Recomp Specialist

export const IMAGES = {
  logo:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_fitcoach-hub-98/artifacts/dei5cih4_logo%20logo.jpg",
  angeloFront:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_fitcoach-hub-98/artifacts/89ol1nd4_Ig%20pic.jpg",
  heroBg:
    "https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxsYXMlMjB2ZWdhcyUyMG5lb24lMjBuaWdodCUyMHNreWxpbmV8ZW58MHx8fHwxNzg2MDc0MjYwfDA&ixlib=rb-4.1.0&q=85",
  trainer:
    "https://images.unsplash.com/photo-1605296866985-34ba3c0b527b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxmaXRuZXNzJTIwdHJhaW5lciUyMGRhcmslMjBsaWdodGluZyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NjA3NDI2MHww&ixlib=rb-4.1.0&q=85",
  bar:
    "https://images.unsplash.com/photo-1628254116228-58e131b7bc56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxiYXJ0ZW5kZXIlMjBtaXhpbmclMjBkcmluayUyMGRhcmslMjBuZW9ufGVufDB8fHx8MTc4NjA3NDI2MHww&ixlib=rb-4.1.0&q=85",
  dumbbell:
    "https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxneW0lMjB3ZWlnaHRzJTIwZGFyayUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4NjA3NDI2MHww&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { value: "4AM", label: "Built for your clock-out" },
  { value: "35–45", label: "Minute recomp sessions" },
  { value: "100%", label: "Service-industry focused" },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Circadian & Energy Management",
    body: "Structure your meals, hydration and caffeine around a shift that ends at 4AM — so you stop crashing at hour six and stop reaching for the junk to stay upright.",
  },
  {
    num: "02",
    title: "Post-Shift Nutrition",
    body: "Kill the 4AM drive-thru and casino food-court run. Rapid, low-friction, high-protein options you can actually pull off exhausted at the end of a double.",
  },
  {
    num: "03",
    title: "Minimalist High-Efficiency Training",
    body: "35–45 minute home or hybrid sessions with dumbbells and bands. Real body recomposition without frying an already-fried central nervous system.",
  },
  {
    num: "04",
    title: "Alcohol & Social Pressure",
    body: "Shift drinks, comped rounds, industry nights. Learn to navigate the social floor without torching your calories or your progress.",
  },
];

export const SERVICES = [
  {
    tag: "Energy",
    title: "Circadian Coaching",
    desc: "Meal timing, caffeine cycling and hydration mapped to your real schedule — not a 9-to-5 fantasy.",
  },
  {
    tag: "Nutrition",
    title: "Post-Shift Fuel Plans",
    desc: "High-protein, low-effort options for 4AM cravings that keep you lean instead of bloated.",
  },
  {
    tag: "Training",
    title: "35-Minute Recomp",
    desc: "Dumbbell + band programming that fits a hotel room, a garage, or a cramped apartment.",
  },
  {
    tag: "Lifestyle",
    title: "Nightlife Navigation",
    desc: "Tactical playbooks for shift drinks, industry nights and social pressure without the guilt.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Angelo actually gets it. No 'sleep by 10' nonsense. I dropped 14 lbs still closing the bar five nights a week.",
    name: "Marcus D.",
    role: "Bartender · The Strip",
  },
  {
    quote:
      "The post-shift meal templates changed everything. I stopped hitting the drive-thru at 4AM and finally have energy.",
    name: "Jenna R.",
    role: "Cocktail Server · Casino Floor",
  },
  {
    quote:
      "35-minute sessions I can do after a double. First coach who built around my life instead of fighting it.",
    name: "Diego M.",
    role: "Host · Nightclub",
  },
];

export const MARQUEE_WORDS = [
  "4AM READY",
  "NO 9-TO-5 RULES",
  "RECOMP SPECIALIST",
  "VEGAS SERVICE INDUSTRY",
  "SHIFT-PROOF NUTRITION",
];

export const ROLES = [
  "Bartender",
  "Server / Cocktail",
  "Host / Nightclub",
  "Cook / Kitchen",
  "Casino Dealer",
  "Security / Valet",
  "Other Late-Shift",
];

export const GOALS = [
  "Fat Loss",
  "Muscle / Recomposition",
  "Energy & Sleep",
  "General Health",
];
